/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_oer_information_quality_text25 = /** @type {(inputs: {}) => string} */ () => {
	return `So far, there is no quality seal for OER materials. Many educators find this unsettling. Similar to Wikipedia, however, members of online communities oversee OER materials. And as these communities grow larger, more subject matter expertise and pedagogical knowledge come together.`
};

const fr_oer_information_quality_text25 = /** @type {(inputs: {}) => string} */ () => {
	return `Jusqu'à présent, il n'existe aucun label de qualité pour les ressources REL. De nombreux enseignants trouvent cela inquiétant. Cependant, à l'instar de Wikipédia, les membres de communautés en ligne supervisent les ressources REL. Et à mesure que ces communautés s'agrandissent, davantage d'expertise thématique et de connaissances pédagogiques se conjuguent.`
};

const de_oer_information_quality_text25 = /** @type {(inputs: {}) => string} */ () => {
	return `Bisher gibt es kein Qualitätssiegel für OER-Materialien. Viele Pädagogen empfinden das als beunruhigend. Ähnlich wie bei Wikipedia betreuen jedoch Mitglieder von Online-Communitys OER-Materialien. Und je größer diese Communities werden, desto mehr Fachwissen und pädagogisches Wissen fließen zusammen.`
};

const es_oer_information_quality_text25 = /** @type {(inputs: {}) => string} */ () => {
	return `Hasta el momento, no existe un sello de calidad para los materiales REA, lo que resulta desconcertante para muchos educadores. Sin embargo, al igual que en Wikipedia, los materiales REA están supervisados por miembros de comunidades en línea. Y a medida que estas comunidades crecen, se combinan más conocimientos especializados y pedagógicos.`
};

const it_oer_information_quality_text25 = /** @type {(inputs: {}) => string} */ () => {
	return `Finora, non esiste un sigillo di qualità per i materiali OER. Molti educatori lo trovano inquietante. Similmente a Wikipedia, tuttavia, i membri delle comunità online supervisionano i materiali OER. E man mano che queste comunità crescono, più competenza in materia e conoscenza pedagogica si uniscono.`
};

const ar_oer_information_quality_text25 = /** @type {(inputs: {}) => string} */ () => {
	return `حتى الآن، لا توجد علامة جودة لمواد الموارد التعليمية المفتوحة. ويرى العديد من المعلمين أن هذا الأمر مزعج. ولكن على غرار ويكيبيديا، يشرف أعضاء المجتمعات عبر الإنترنت على مواد الموارد التعليمية المفتوحة. ومع نمو هذه المجتمعات، تتجمع المزيد من الخبرات في الموضوع والمعرفة التربوية.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const oer_information_quality_text25 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oer_information_quality_text25(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oer_information_quality_text25", locale)
	if (locale === "en") return en_oer_information_quality_text25(inputs)
	if (locale === "fr") return fr_oer_information_quality_text25(inputs)
	if (locale === "de") return de_oer_information_quality_text25(inputs)
	if (locale === "es") return es_oer_information_quality_text25(inputs)
	if (locale === "it") return it_oer_information_quality_text25(inputs)
	return ar_oer_information_quality_text25(inputs)
};
export { oer_information_quality_text25 as "OER_INFORMATION_QUALITY_TEXT" }